module.exports = __webpack_public_path__ + "images/svg/contact_icon_white_outline_adress.svg";